import {handleActions} from 'redux-actions';

import {SIGN_OUT} from '/redux/action/auth.action';
import {
  CANCEL_SEARCH,
  GET_RECENT_SEARCHES,
  GET_SEARCH_RESULTS,
  SET_IS_LOADING,
  UPDATE_RECENT_SEARCHES,
  UPDATE_SEARCH_INPUT,
} from '/redux/action/search.action';
import {withPayload} from '/util/reducer.util';

import {endSearch} from './search/endSearch';
import {setIsLoading} from './search/setIsLoading';
import {updateRecentSearches} from './search/updateRecentSearches';
import {updateSearchInput} from './search/updateSearchInput';
import {updateSearchResults} from './search/updateSearchResults';

const initialState = {
  allSearchResults: {},
  searchInput: '',
  allSearchMeta: {},
  recentSearches: [],
};

export const search = handleActions(
  {
    [GET_SEARCH_RESULTS]: withPayload(updateSearchResults),
    [UPDATE_SEARCH_INPUT]: withPayload(updateSearchInput),
    [SET_IS_LOADING]: withPayload(setIsLoading),
    [CANCEL_SEARCH]: withPayload(endSearch),
    [UPDATE_RECENT_SEARCHES]: withPayload(updateRecentSearches),
    [GET_RECENT_SEARCHES]: withPayload(updateRecentSearches),
    [SIGN_OUT]: withPayload(endSearch),
  },
  initialState,
);
